module.exports = __webpack_public_path__ + "img/arrow-right.bb38f7b6.svg";